var AudioPlayerStatus = /* @__PURE__ */ ((AudioPlayerStatus2) => {
  AudioPlayerStatus2["LOAD_ERROR"] = "loadError";
  AudioPlayerStatus2["PLAY_ERROR"] = "playError";
  AudioPlayerStatus2["UNLOADED"] = "unloaded";
  AudioPlayerStatus2["LOADING"] = "loading";
  AudioPlayerStatus2["LOADED"] = "loaded";
  AudioPlayerStatus2["PLAYING"] = "playing";
  AudioPlayerStatus2["PAUSING"] = "pausing";
  AudioPlayerStatus2["STOPPING"] = "stopping";
  AudioPlayerStatus2["ENDED"] = "ended";
  return AudioPlayerStatus2;
})(AudioPlayerStatus || {});
((AudioPlayerStatus2) => {
  function fromString(audioPlayerStatus) {
    switch (audioPlayerStatus) {
      case "loadError":
        return "loadError" /* LOAD_ERROR */;
      case "playError":
        return "playError" /* PLAY_ERROR */;
      case "unloaded":
        return "unloaded" /* UNLOADED */;
      case "loading":
        return "loading" /* LOADING */;
      case "loaded":
        return "loaded" /* LOADED */;
      case "playing":
        return "playing" /* PLAYING */;
      case "pausing":
        return "pausing" /* PAUSING */;
      case "stopping":
        return "stopping" /* STOPPING */;
      case "ended":
        return "ended" /* ENDED */;
      default:
        return void 0;
    }
  }
  AudioPlayerStatus2.fromString = fromString;
})(AudioPlayerStatus || (AudioPlayerStatus = {}));

export { AudioPlayerStatus };
//# sourceMappingURL=audio-player.enum.js.map
